import { render, staticRenderFns } from "./generalSettings.vue?vue&type=template&id=2baab0a2&scoped=true&"
import script from "./generalSettings.vue?vue&type=script&lang=ts&"
export * from "./generalSettings.vue?vue&type=script&lang=ts&"
import style0 from "./generalSettings.vue?vue&type=style&index=0&id=2baab0a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baab0a2",
  null
  
)

export default component.exports